import { CsvAnalysis, CsvColumnInfo, CsvDataType } from "../types/CsvAnalysis";
import Papa from 'papaparse';

export const analyzeCsv = (
    file: File
): Promise<CsvAnalysis> => {
    return new Promise((resolve, reject) => {
        Papa.parse<Record<string, string>>(file, {
            header: true,
            skipEmptyLines: true,

            complete: (results) => {
                if (results.errors.length > 0) {
                    reject(results.errors);
                    return;
                }

                const rows = results.data;
                const headers = (results.meta.fields ?? [])
                    .map((header) => header.trim())
                    .filter(Boolean);

                const columns: CsvColumnInfo[] = headers.map(
                    (columnName) => {
                        const values = rows
                            .map((row) => row[columnName])
                            .filter(
                                (value): value is string =>
                                    value !== undefined &&
                                    value !== null &&
                                    value.trim() !== ''
                            );

                        const detectedTypes = [
                            ...new Set(
                                values.map((value) => detectValueType(value))
                            )
                        ];

                        let type: CsvDataType = 'empty';

                        if (detectedTypes.length === 1) {
                            type = detectedTypes[0];
                        } else if (detectedTypes.length > 1) {
                            type = 'mixed';
                        }

                        return {
                            name: columnName,
                            type,
                            totalValues: values.length,
                        };
                    }
                );

                resolve({
                    totalRows: rows.length,
                    totalColumns: headers.length,
                    columns,
                });
            },
            error: (error) => reject(error)
        });
    });
};

const detectValueType = (value: string): CsvDataType => {
    const trimmedValue = value.trim();

    if (trimmedValue === '') {
        return 'empty';
    }

    if (/^(true|false)$/i.test(trimmedValue)) {
        return 'boolean';
    }

    if (
        trimmedValue !== '' &&
        !Number.isNaN(Number(trimmedValue))
    ) {
        return 'number';
    }

    const date = new Date(trimmedValue);

    if (!Number.isNaN(date.getTime())) {
        return 'date';
    }

    return 'string';
};